<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div>
  <app-pba-settings [d3ePolicy]="d3ePolicy" (onChanged)="onPbaInfoChanged()"></app-pba-settings>
</div>
